<footer>
  <nav class="footer__links" aria-label="{{ 'footer.cgu' | translate }}">
    <a class="footer__link" [href]="cguHref" target="_blank" rel="noopener noreferrer">
      {{ 'footer.cgu' | translate }}
    </a>
    <a class="footer__link" [href]="legalNoticeHref" target="_blank" rel="noopener noreferrer">
      {{ 'footer.legal_notice' | translate }}
    </a>
    <a class="footer__link" [href]="usageHref" target="_blank" rel="noopener noreferrer">
      {{ 'footer.usage' | translate }}
    </a>
  </nav>
  <span class="footer__copyright">TotalEnergies - Web & Portals Studio {{ currentYear }} ©</span>
</footer>
